import * as React from 'react';
import './Input.scss';

export enum IInputType {
    password = 'password',
    text = 'text',
    tel = 'tel',
}

export interface IProps {
    label: string;
    value: string;
    hasError?: boolean;
    errorLabel?: string;
    type?: IInputType;
    noBottomMargin?: boolean;
    name?: string;
}

export interface IFunctions {
    onChange: (value: string) => void;
}

export type IAllProps = IProps & IFunctions;

export const Input: React.SFC<IAllProps> = ({
    label,
    value,
    onChange,
    type,
    noBottomMargin,
    name,
    hasError,
    errorLabel,
}) =>
    <div
        className={`Input-wrap
            ${noBottomMargin && 'no-bottom-margin'}
            ${hasError && 'with-error'}
        `}>
        <label>{label}</label>
        <input
            type={type || IInputType.text}
            value={value}
            onChange={e => onChange(e.currentTarget.value)}
            name={name || ''}
        />
        {hasError && <span className="error-label">{errorLabel || ''}</span>}
    </div>;

export default Input;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/form/input/Input.tsx